import { useState } from "react";
import background from "../images/Kontakt forma.png";
import checkmark from "../images/check-mark.png";
import { RegistrationDto } from "../utils/types/registration";
import { submitRegistration } from "../utils/registrationService";
import x1921 from "../images/check-mark 1.png";

const FormSection = () => {
  const [name, setName] = useState("");
  const [agency, setAgency] = useState("");
  const [agencyType, setAgencyType] = useState(""); 
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [submitted, setSubmitted] = useState(false); 
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const [loading, setLoading] = useState(false);

  const validate = () => {
    const newErrors: { [key: string]: string } = {};
    if (!name.trim()) newErrors.name = "Ime je obavezno";
    if (!agency.trim()) newErrors.agency = "Naziv agencije je obavezan";
    if (!agencyType) newErrors.agencyType = "Tip agencije je obavezan";
    if (!email.trim()) newErrors.email = "Email je obavezan";
    else if (!/\S+@\S+\.\S+/.test(email)) newErrors.email = "Email nije validan";
    return newErrors;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setErrors({});
    setLoading(true);

    const payload: RegistrationDto = {
      name,
      agencyName: agency,
      agencyType: agencyType === "organizer" ? 0 : 1,
      email,
      phone: phone || undefined,
      location: 4 //hardcoded for MerakzyCom
    };

    try {
      await submitRegistration(payload);
      setSubmitted(true);

      setName("");
      setAgency("");
      setAgencyType("");
      setEmail("");
      setPhone("");
    } catch (error) {
      console.error(error);
      alert("Се случи неочекувана грешка при регистрацијата. Ве молиме проверете ги податоците и обидете се повторно.");
    } finally {
      setLoading(false);
    }
  };

if (submitted) {
  return (
   <section className="relative bg-[#F5F5F5] py-12 md:py-24">
    <div className="max-w-[1200px] mx-auto px-4 md:px-6 flex flex-col lg:flex-row gap-12 md:gap-16">
      
      {/* LEFT SIDE */}
      <div className="flex-1 text-left">
        <div className="w-[180px] h-[36px] relative mb-6">
          <div className="absolute top-1 left-1 w-6 h-6 flex rounded-[20px]">
            <img className="w-6 h-6" alt="" src={background} />
          </div>
          <div className="absolute top-2 left-9 h-[16px] flex items-center justify-center font-semibold text-[#0c0407] text-xs md:text-sm leading-[16px] whitespace-nowrap">
            САКАТЕ ДА ГО ПРОБАТЕ MERAKZY
          </div>
        </div>

        <h1 className="text-3xl md:text-5xl font-bold text-[#0c0407] leading-snug md:leading-tight mb-6 md:mb-8">
           Оставете ги <br />
           податоците и <br />
           набрзо ќе добиете <br />
           пристап до демото.
        </h1>           

        <div className="flex flex-col gap-2 md:gap-3">
          <p className="flex items-center gap-2 md:gap-3 text-[#555] text-sm md:text-base leading-6 md:leading-7">
            <img src={checkmark} width={20} className="md:w-6" alt="check" />
            Поддршката од тимот е достапна во секое време
          </p>
        </div>
      </div>

      {/* RIGHT SIDE */}
      <div className="flex-1 w-full">
        <div className="bg-white rounded-3xl shadow-sm border border-[#0000001a] py-24 h-full flex items-center justify-center">
          {submitted ? (
            // ✅ SUCCESS MESSAGE (this part only replaces the form)
            <div className="text-center flex flex-col items-center justify-center h-full py-20 px-5">
                 <img src={x1921} alt="Merakzy Logo" className="w-20 h-20 mb-6" />
              <h1 className="text-3xl md:text-5xl font-bold text-[#0c0407] mb-6">
                Податоците <br/> се испратени!
              </h1>
              <p className="text-[#555] text-lg">
                Ви благодариме. Наскоро ќе добиете <br/>                
                пристап до демото
              </p>
              {/* 👉 you can place your placeholder or any additional content here */}
            </div>
          ) : (
            // 🧾 FORM CONTENT
            <form className="flex flex-col gap-4 md:gap-6 w-full" onSubmit={handleSubmit}>
              {/* (your existing input fields and button stay the same) */}
            </form>
          )}
        </div>
      </div>
    </div>
  </section>
  );
}

  return (
   <section className="w-full relative bg-[#F8F8F8] py-12 md:py-24">
      <div className="mx-auto container px-4 md:px-6 flex flex-col lg:flex-row  gap-12 md:gap-16">

        <div className="flex-1 text-left">
          <div className="w-[180px] h-[36px] relative mb-6">
            <div className="absolute top-1 left-1 w-6 h-6 flex rounded-[20px]">
              <img className="" alt="" src={background} />
            </div>
            <div className="absolute top-2 left-9 h-[16px] flex items-center justify-center font-semibold text-[#0c0407] text-xs md:text-sm leading-[16px] whitespace-nowrap">
              САКАТЕ ДА ГО ПРОБАТЕ MERAKZY
            </div>
          </div>

          <h1 className="text-3xl md:text-5xl font-semibold text-[#0c0407] leading-snug md:leading-tight mb-6 md:mb-8">
              Оставете ги <br />
              податоците и <br />
              набрзо ќе добиете <br />
              пристап до демото.
          </h1>

          <div className="flex flex-col gap-2 md:gap-3">
            <p className="flex items-center gap-2 md:gap-3 text-[#555] text-sm md:text-base leading-6 md:leading-7">
              <img src={checkmark} width={20} className="md:w-6" alt="check" />
              Поддршката од тимот е достапна во секое време
            </p>
          </div>
        </div>

        <div className="flex-1 w-full">
          <div className="bg-white rounded-3xl shadow-sm border border-[#0000001a] p-6 md:p-10">
            <form className="flex flex-col gap-4 md:gap-6" onSubmit={handleSubmit}>

              <div className="flex flex-col text-left">
                <label htmlFor="name" className="font-semibold text-[#0c0407] mb-1 md:mb-2 text-sm md:text-base">
                  Име и презиме*
                </label>
                <input
                  id="name"
                  type="text"
                  placeholder="Вашето целосно име"
                  className={`h-12 md:h-[50px] w-full rounded-[25px] border px-3 md:px-5 text-[#0c0407] focus:outline-none focus:ring-2 focus:ring-[#fa0053] ${errors.name ? "border-red-500" : "border-[#d1d1d1]"}`}
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
                {errors.name && <p className="text-red-500 text-xs md:text-sm mt-1">{errors.name}</p>}
              </div>

              <div className="flex flex-col text-left">
                <label htmlFor="agency" className="font-semibold text-[#0c0407] mb-1 md:mb-2 text-sm md:text-base">
                  Име на агенцијата*
                </label>
                <input
                  id="agency"
                  type="text"
                  placeholder="Име на агенцијата"
                  className={`h-12 md:h-[50px] w-full rounded-[25px] border px-3 md:px-5 text-[#0c0407] focus:outline-none focus:ring-2 focus:ring-[#fa0053] ${errors.agency ? "border-red-500" : "border-[#d1d1d1]"}`}
                  value={agency}
                  onChange={(e) => setAgency(e.target.value)}
                />
                {errors.agency && <p className="text-red-500 text-xs md:text-sm mt-1">{errors.agency}</p>}
              </div>

              <div className="flex flex-col text-left">
                <span className="font-semibold text-[#0c0407] mb-1 md:mb-2 text-sm md:text-base">Тип на агенцијата*</span>
                <div className="flex flex-col gap-2 text-sm md:text-base">
                  <label className="flex items-center gap-2 md:gap-3">
                    <input
                      type="radio"
                      name="agencyType"
                      value="organizer"
                      className="mt-0.5 w-4 h-4 accent-[#fa0053] shrink-0"
                      checked={agencyType === "organizer"}
                      onChange={(e) => setAgencyType(e.target.value)}
                    />
                    <span>
                      <span className="font-bold">Организатор</span>. Имам сопствени соби на закуп.
                    </span>
                  </label>

                  <label className="flex items-center gap-2 md:gap-3">
                    <input
                      type="radio"
                      name="agencyType"
                      value="reseller"
                      className="mt-0.5 w-4 h-4 accent-[#fa0053] shrink-0"
                      checked={agencyType === "reseller"}
                      onChange={(e) => setAgencyType(e.target.value)}
                    />
                    <span>
                      <span className="font-bold">Туристичка агенција</span>. Моментално препродавам, но со добар софтвер би размислил и за закуп на сопствени соби.
                    </span>
                  </label>
                </div>
                {errors.agencyType && <p className="text-red-500 text-xs md:text-sm mt-1">{errors.agencyType}</p>}
              </div>

              <div className="flex flex-col text-left">
                <label htmlFor="email" className="font-semibold text-[#0c0407] mb-1 md:mb-2 text-sm md:text-base">Мејл*</label>
                <input
                  id="email"
                  type="email"
                  placeholder="Вашата мејл адреса"
                  className={`h-12 md:h-[50px] w-full rounded-[25px] border px-3 md:px-5 text-[#0c0407] focus:outline-none focus:ring-2 focus:ring-[#fa0053] ${errors.email ? "border-red-500" : "border-[#d1d1d1]"}`}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                {errors.email && <p className="text-red-500 text-xs md:text-sm mt-1">{errors.email}</p>}
              </div>

              <div className="flex flex-col text-left">
                <label htmlFor="phone" className="font-semibold text-[#0c0407] mb-1 md:mb-2 text-sm md:text-base">Телефон*</label>
                <input
                  id="phone"
                  type="tel"
                  placeholder="000 000 000"
                  className="h-12 md:h-[50px] w-full rounded-[25px] border border-[#d1d1d1] px-3 md:px-5 text-[#0c0407] focus:outline-none focus:ring-2 focus:ring-[#fa0053]"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                />
              </div>

              <button
                type="submit"
                className="mt-4 w-full h-12 md:h-[50px] flex items-center justify-center text-white font-bold rounded-[16px] hover:opacity-90 transition-opacity"
                style={{ background: "linear-gradient(90deg, #FA0053 0%, #B6003C 104.69%)" }}
              >
                Испратете
              </button>

            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FormSection;